import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [
    "editNumber", "editIdNumber", "editNameEn", "editNameAr", "editContractCode", "editType", "editMainAccount",
    "mainAccountContainer", "editMainAccountContainer", "contractCode", "newMainAccount", "typeSelect", "editId",
    "editForm", "confirmContractChangeModal", "confirmContractChangeMessage"
  ]

  connect() {
    // Initial check on page load for new insured form
    if (this.hasTypeSelectTarget) {
      this.toggleMainAccount({ target: this.typeSelectTarget })
    }
  }

  edit(event) {
    event.preventDefault()
    const data = event.params

    // Store original contract code for comparison
    this.originalContractCode = data.contractCode
    this.currentSubsCount = data.subsCount
    this.currentType = data.type

    // Populate fields
    this.editNumberTarget.value = data.number
    this.editNumberTarget.disabled = true

    this.editIdNumberTarget.value = data.idNumber
    this.editIdNumberTarget.disabled = true

    this.editNameEnTarget.value = data.nameEn
    this.editNameArTarget.value = data.nameAr
    this.editContractCodeTarget.value = data.contractCode
    this.editTypeTarget.value = data.type
    this.editIdTarget.value = data.id

    // Logic for disable/enable based on type and subscription count
    if (data.type === "sub") {
      // Sub-accounts cannot change contract - always disabled
      this.editContractCodeTarget.disabled = true
      this.editTypeTarget.disabled = true
    } else {
      // Main accounts can change contract (even with subs - will trigger confirmation)
      this.editContractCodeTarget.disabled = false
      // Type can only change if no subs
      this.editTypeTarget.disabled = data.subsCount > 0
    }

    // Show/Hide main account field based on type
    if (data.type === "sub") {
      this.editMainAccountContainerTarget.style.display = "inline"
      this.editMainAccountTarget.required = true
      // Fetch main accounts
      this.fetchMainAccounts(data.contractCode, this.editMainAccountTarget, data.parentAccount, data.number)
    } else {
      this.editMainAccountContainerTarget.style.display = "none"
      this.editMainAccountTarget.required = false
    }

    $('#edit_insured_detail').modal('show')
  }

  // Handle form submission with confirmation for main accounts with subs
  handleEditFormSubmit(event) {
    const newContractCode = this.editContractCodeTarget.value

    // If main account with subs and contract changed, show confirmation
    if (this.currentType === "main" &&
      this.currentSubsCount > 0 &&
      newContractCode !== this.originalContractCode) {
      event.preventDefault()

      // Update confirmation message with sub count
      if (this.hasConfirmContractChangeMessageTarget) {
        const messageEn = `This will also update the contract for ${this.currentSubsCount} sub-account(s). Do you want to continue?`
        const messageAr = `سيتم أيضاً تحديث العقد لـ ${this.currentSubsCount} حساب(ات) فرعي. هل تريد المتابعة؟`
        // Use Arabic or English based on current locale
        const isArabic = document.documentElement.lang === 'ar' || window.location.href.includes('locale=ar')
        this.confirmContractChangeMessageTarget.textContent = isArabic ? messageAr : messageEn
      }

      $('#confirm_contract_change_modal').modal('show')
    }
    // Otherwise, form submits normally
  }

  // Confirm contract change and submit form
  confirmContractChange() {
    $('#confirm_contract_change_modal').modal('hide')
    // Submit the form
    if (this.hasEditFormTarget) {
      this.editFormTarget.submit()
    } else {
      document.querySelector('#edit_insured_detail form').submit()
    }
  }

  // Cancel contract change
  cancelContractChange() {
    $('#confirm_contract_change_modal').modal('hide')
    // Reset contract to original value
    this.editContractCodeTarget.value = this.originalContractCode
  }

  contractCodeChanged(event) {
    const code = event.target.value
    if (code !== "") {
      this.fetchMainAccounts(code, this.newMainAccountTarget)
      this.typeSelectTarget.disabled = false
    } else {
      this.mainAccountContainerTarget.style.display = "none"
      this.newMainAccountTarget.required = false
      this.newMainAccountTarget.value = ""
      this.typeSelectTarget.value = ""
      this.typeSelectTarget.disabled = true
    }
  }

  editContractCodeChanged(event) {
    const code = event.target.value
    const currentInsuredNumber = this.editNumberTarget.value

    if (code === "") {
      this.editMainAccountContainerTarget.style.display = "none"
      this.editMainAccountTarget.required = false
      this.editMainAccountTarget.value = ""
      this.editTypeTarget.value = ""
      this.editTypeTarget.disabled = true
    } else {
      this.fetchMainAccounts(code, this.editMainAccountTarget, null, currentInsuredNumber)
      this.editTypeTarget.disabled = false
    }
  }

  toggleMainAccount(event) {
    const type = event.target.value
    if (type === "sub") {
      this.mainAccountContainerTarget.style.display = "inline"
      this.newMainAccountTarget.required = true
    } else {
      this.mainAccountContainerTarget.style.display = "none"
      this.newMainAccountTarget.required = false
    }
  }

  toggleEditMainAccount(event) {
    const type = event.target.value
    if (type === "sub") {
      this.editMainAccountContainerTarget.style.display = "inline"
      this.editMainAccountTarget.required = true
      this.fetchMainAccounts(this.editContractCodeTarget.value, this.editMainAccountTarget, null, this.editNumberTarget.value)
    } else {
      this.editMainAccountContainerTarget.style.display = "none"
      this.editMainAccountTarget.required = false
      this.editMainAccountTarget.value = ""
    }
  }

  fetchMainAccounts(code, selectElement, parentInsuranceNumber = null, insuranceNumber = null) {
    if (parentInsuranceNumber) {
      selectElement.value = parentInsuranceNumber
    }

    // Logic to fetch main accounts via AJAX
    // Note: The original JS had this AJAX call commented out or partially implemented.
    // If the endpoint /admin/insureds/main_accounts exists and returns JSON, uncomment below:

    /*
    $.ajax({
      type: "get",
      url: "/admin/insureds/main_accounts",
      dataType: "json",
      data: { contract_code: code },
      success: (result) => {
        // Clear options except first
        while (selectElement.options.length > 1) {
          selectElement.remove(1);
        }
        
        result.insureds.forEach(item => {
          if (item.Insured.insured_number != insuranceNumber) {
            const opt = document.createElement("option")
            opt.value = item.Insured.insured_number
            opt.innerHTML = item.Insured.insured_name_ar
            selectElement.appendChild(opt)
          }
        })
        
        if (parentInsuranceNumber) {
          selectElement.value = parentInsuranceNumber
        }
      }
    })
    */
  }
}

